import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AccountBackend } from '@libs/src/account/account.backend';
import { ToastService } from '@libs/src/toast/toast.service';

import { Account } from '@libs/src/models/account.model';

@Component({
  selector: 'app-email-verification-banner',
  templateUrl: './email-verification-banner.component.html',
})
export class EmailVerificationBannerComponent {
  @Input() user: Account;

  constructor(
    private accountBackend: AccountBackend,
    private toastService: ToastService,
  ) {}

  resendVerificationEmail() {
    return this.accountBackend
      .resendSignUpEmail()
      .pipe(
        catchError((responseError: HttpErrorResponse) => {
          this.toastService.showError(responseError.error.message);
          return EMPTY;
        }),
      )
      .subscribe(() => {
        this.toastService.showSuccess(`We've resent your verification email!`);
      });
  }
}
